const Genesis = require("../Genesis.js")
let PropertyAutoComplete = require("./assetsearch.js");
export class ISiteMobileAssetPropertySearchPage {
    constructor() { }
    public Init() {
        PropertyAutoComplete();
    }
};